import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core'
import { Chart } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { DetailsAndScoreResponse } from '../../../models/flip/details-scores-response'
import { interval, throttleTime } from 'rxjs'
import { CommonService } from '../../../services/common/common.service'

@Component({
  selector: 'app-flip-subscore-graph',
  imports: [],
  templateUrl: './flip-subscore-graph.component.html',
  styleUrl: './flip-subscore-graph.component.scss',
})
export class FlipSubscoreGraphComponent implements AfterViewInit, OnDestroy {
  @Input() detailsAndScore!: DetailsAndScoreResponse
  private chart: Chart

  constructor(public commonService: CommonService) {}

  ngAfterViewInit(): void {
    this.initChart()
  }

  initChart() {
    if (!this.detailsAndScore?.flipSubScores) return

    const labels = this.detailsAndScore.flipSubScores.map((s) => s.name)
    const data = this.detailsAndScore.flipSubScores.map(
      (s) => s.percentScoreRounded,
    )

    if (this.chart) {
      this.chart.destroy()
    }

    this.chart = new Chart('noiseBarChart', {
      type: 'bar',
      data: {
        labels,
        datasets: [
          {
            data,
            backgroundColor: data.map((v) => (v > 0 ? '#009999' : '#cccccc')),
          },
        ],
      },
      plugins: [ChartDataLabels],
      options: {
        indexAxis: 'y',
        animation: false,
        responsive: true,
        plugins: {
          datalabels: {
            color: '#fff',
            font: { size: 10 },
            anchor: 'end',
            clamp: true,
            clip: true,
            align: 'left',
            formatter: (value, context) => {
              const index = context.dataIndex
              const score = this.detailsAndScore.flipSubScores[index]
              return `${score.numberOfItems} (${score.percentScoreRounded}%)`
            },
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const index = context.dataIndex
                const score = this.detailsAndScore.flipSubScores[index]
                return [
                  `Name: ${score.name}`,
                  `Items: ${score.numberOfItems} (${score.percentScoreRounded}%)`,
                ]
              },
            },
          },
          legend: { display: false },
        },
        scales: {
          x: {
            min: 0,
            max: 100,
            ticks: {
              callback: (v) => v + '%',
            },
          },
        },
      },
    })
  }

  ngOnDestroy(): void {
    this.chart?.destroy()
  }
}
